import * as React from 'react';
import { observer } from 'mobx-react';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import MeetingActionButton from './MeetingActionButton';
import { setResponseType } from '../mutators/setResponseType';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import {
    acceptedButtonLabel_0,
    tentativelyAcceptedButtonLabel_0,
    declinedButtonLabel_0,
} from './UpdateResponseButton.locstring.json';

export interface UpdateResponseButtonProps {
    viewState: MeetingRequestViewState;
    disableInteraction: boolean;
}

@observer
export default class UpdateResponseButton extends React.Component<UpdateResponseButtonProps, {}> {
    render() {
        const {
            viewState: { responseType },
        } = this.props;
        const buttonProps = this.getButtonProps(responseType);
        return (
            buttonProps && (
                <MeetingActionButton
                    text={buttonProps.text}
                    secondary={true}
                    iconProps={{
                        iconName: buttonProps.iconName,
                    }}
                    onClick={this.onClick}
                />
            )
        );
    }

    private onClick = () => {
        if (!this.props.disableInteraction) {
            setResponseType(this.props.viewState, 'NoResponseReceived');
        }
    };

    private getButtonProps(
        responseType: ResponseTypeType
    ): { text: string; iconName: string } | null {
        switch (responseType) {
            case 'Accept':
                return { text: loc(acceptedButtonLabel_0), iconName: ControlIcons.Accept };
            case 'Tentative':
                return { text: loc(tentativelyAcceptedButtonLabel_0), iconName: ControlIcons.Help };
            case 'Decline':
                return { text: loc(declinedButtonLabel_0), iconName: ControlIcons.Cancel };
            default:
                return null;
        }
    }
}
